<template>
  <div>
    <b-row>
      <b-colxx xxs="12">

        <b-row align-v="center" align-h="center" class="mt-4" no-gutters>
          <b-col cols="6">
            <b-form-group label="상품유형" class="weight600">
              <b-input-group size="sm">
                <span>{{ goodsType != null ? _goodsTypeOption.find(x => x.value == goodsType).text : '' }}</span>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col cols="6">
            <b-form-group label="상품명" class="weight600">
              <!-- <b-input-group size="sm"> -->
              <b-form-input type="text" v-model="_goodsName" :readonly="this.isModifyMode != false"/>
              <!-- </b-input-group> -->
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col cols="6" class="mb-2">
            <b-form-group label="상품명 태그" class="weight600">
              <!--              <b-input-group size="sm">-->
              <b-form-input type="text" v-model="_goodsTag"
                            placeholder="(선택항목) 상품명에 대한 간단한 부가정보로 쿠폰확인시 매장직원에게만 보여집니다."/>
              <!--              </b-input-group>-->
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col cols="6" class="mb-2">
            <b-form-group label="상품설명" class="weight600">
              <!--              <quill-editor class="bubble"-->
              <!--                            ref="myTextEditorBubble"-->
              <!--                            v-model="_intro"-->
              <!--                            :options="editorOptionBubble">-->
              <!--              </quill-editor>-->
              <b-form-input type="text" v-model="_intro" placeholder="상품에 대한 소개를 작성합니다."/>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col cols="6">
            <b-form-group label="대표 이미지" class="weight600">
              <b-form-row>
                <sortable-file-uploader @usefilesData="usefilesData" @spinningeve="spinningeve" :parantRemove='null'
                                        :clicktrue="null" :sortable="'hold'" :container="'GOODS'" :compact="true"
                                        :max-files="1" :defaultFiles="tempMainContent" :Reflect="ReflectVal"
                                        @getFileData="mainImageHandling"></sortable-file-uploader>
                <div class="dip">
                  <button class="btn top-right-button btn-outline-success btn-sm ml-2" @click="repImageModal">매장 이미지에서
                    선택
                  </button>
                </div>
              </b-form-row>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col cols="6">
            <b-form-group label="추가 이미지" class="weight600">
              <transition-group name="list" tag="ul">
<!--                {{ _subImages }}-->
                <sub-image-content-viewer v-for="(subImage) in _subImages" :key="subImage.id" :data="subImage"
                                          @remove-sub-image-content="removeSubImageContent"
                                          @edit-sub-image-content="editSubImageContent"
                                          @move-up-sub-image-content="moveUpSubImageContent"
                                          @move-down-sub-image-content="moveDownSubImageContent"/>
              </transition-group>

            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col md="auto">
            <b-button variant="outline-success" size="sm" @click="openSubContentModal('modalbackdrop')">서브 이미지 추가
            </b-button>
          </b-col>
        </b-row>

        <!-- 서브이미지 추가모달 -->
        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-modal id="modalbackdrop" ref="modalbackdrop" size="lg bigmodal" title="서브 이미지 콘텐츠" :hide-backdrop="false"
                   :no-close-on-backdrop="true">
            <b-row>
              <b-colxx xxs="12">
                <div :class="subtext == true ?  'juu' : ''">
                  <div class="useimgdiv1" v-show="subtext">
                    <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
                      <b-col>
                        <b-form-group label="이미지 제목">
                          <b-input-group size="sm">
                            <b-form-input type="text" v-model="tempSubContent.title"/>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
                      <b-col>
                        <b-form-group label="이미지 설명">
                          <b-form-input type="text" v-model="tempSubContent.description"/>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
                      <b-col>
                        <b-form-group label="이미지(최대 3개)">
                          <b-form-checkbox v-model="addStoreImgUse" :value='true' :unchecked-value='false'>매장 이미지 사용
                          </b-form-checkbox>
<!--                          {{ tempSubContent2.images }}-->
                          <StoreFileUpLoad ref="subImages" :newsubimguse="newsubimguse" :fakeIndex="fakeIndex"
                                           @newimgadd="newsubimgstoreadd " :subImagesBtnType='subImagesBtnType'
                                           :defaultFiles="tempSubContent2.images" :reqImgBackground2="reqImgBackground2"
                                           :container="'GOODS'" @getFileData="subImageHandling2"></StoreFileUpLoad>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="useimgdiv2">
                    <div class="imgBoxDivGroup">
                      <div v-if="addStoreImgUse">
                        <div class="imgDragbox" style="background: #dedede;">

                          <div class="imgDragbox-div">
                            <select class="form-control imgdragselect" v-model="imgdragselect" @change="storeImgList">
                              <option v-for="(store,idx) in storeList" :value="store.value" :selected="imgdragselect"
                                      :key="idx">{{ store.label }}
                              </option>
                            </select>
                            <button @click="usestoreedit('sub')" type="button" class="btn btn-default">이용 가능 매장 수정
                            </button>
                          </div>
                          <ul class="titleArr">
                            <li class="cls_click" v-for="(titem,idx) in titleArr" :key="idx"
                                @click="titleArrClcik(titem)">
                              <a>{{ titem.title }}</a>
                            </li>
                          </ul>
                          <div>
                            <ul class="tab">
                              <li v-for="title in storeTitleList" :key="title">{{ title }}</li>
                            </ul>
                          </div>
                          <div id="holder" class="dropImgBox" v-on:dragover="allowDrop" v-on:drop="ondrop($event,1)"
                               @dragenter="onDragenter" style="width:100%;height:400px">
                            <img v-for="(img,idx) in imgDragList" :key="idx" class="imgboxChild" :src="img.url"
                                 :width="img.width" :height="img.height" draggable="true" v-on:dragstart="drag"
                                 :id="'imgidx'+idx">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="height:400px" v-if="showDragImg2">
                      <AvailableStore></AvailableStore>
                      <div class="text-center mt-4">
                        <button @click="storeAddSelect('sub')" type="button" class="ml-1 btn btn-primary">반영</button>
                        <button @click="storeTableClose('sub')" type="button" class="ml-1 btn btn-primary">취소</button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-colxx>
            </b-row>

            <template slot="modal-footer">
              <b-button variant="outline-primary" @click="cancelSubImageContents">취소</b-button>
              <b-button v-if="openModalForModify" variant="primary" @click="updateSubImageContents(tempSubContent.id)"
                        class="mr-1">수정
              </b-button>
              <b-button v-else variant="primary" @click="addSubImageContents" class="mr-1">추가
              </b-button>
            </template>

          </b-modal>
        </b-row>

        <!-- 2022-02-14 매장이미지 추가 -->
        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-modal id="storeimgdlg" ref="storeimgdlg" size="lg bigmodal" title="대표 이미지" :hide-backdrop="false"
                   :no-close-on-backdrop="true">
            <b-row>
              <b-colxx xxs="12">

                <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
                  <b-col>
                    <div class="imgBoxDivGroup" v-if="showDragImg">
                      <div class="partentDiv main">
                        <StoreFileUpLoad :newsubimguse="newsubimguse" :fakeIndex="null" @newimgadd="newmainimgstoreadd"
                                         :subImagesBtnType='null' :defaultFiles="tempMainContent2" :container="'GOODS'"
                                         @getFileData="mainImageHandling2" :max-files="1"></StoreFileUpLoad>

                        <div class="text-center mt-2">
                          <button type="button" class="btn top-right-button btn-outline-success btn-sm"
                                  @click="imgReflect">반영
                          </button>
                        </div>
                      </div>
                      <div class="imgDragbox" style="background: #dedede;">
                        <div class="imgDragbox-div">
                          <select class="form-control imgdragselect" v-model="imgdragselect" @change="storeImgList">
                            <option v-for="(store,idx) in storeList" :value="store.value" :selected="imgdragselect"
                                    :key="idx">{{ store.label }}
                            </option>
                          </select>
                          <button @click="usestoreedit('represent')" type="button" class="btn btn-default">이용 가능 매장 수정
                          </button>
                        </div>
                        <ul class="titleArr">
                          <li class="cls_click" v-for="(titem,idx) in titleArr" :key="idx"
                              @click="titleArrClcik(titem)">
                            <a>{{ titem.title }}</a>
                          </li>
                        </ul>
                        <div>
                          <ul class="tab">
                            <li v-for="title in storeTitleList" :key="title">{{ title }}</li>
                          </ul>
                        </div>
                        <div id="holder" class="dropImgBox" v-on:dragover="allowDrop" v-on:drop="ondrop($event,1)"
                             @dragenter="onDragenter" style="width:100%;height:400px">
                          <img v-for="(img,idx) in imgDragList" :key="idx" class="imgboxChild" :src="img.url"
                               :width="img.width" :height="img.height" draggable="true" v-on:dragstart="drag"
                               :id="'imgidx'+idx">
                        </div>
                      </div>
                    </div>
                    <div style="height:400px" v-else>
                      <AvailableStore></AvailableStore>
                      <div class="text-center mt-4">
                        <button @click="storeAddSelect('represent')" type="button" class="ml-1 btn btn-primary">반영
                        </button>
                        <button @click="storeTableClose('represent')" type="button" class="ml-1 btn btn-primary">취소
                        </button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-colxx>
            </b-row>
            <template slot="modal-footer">
              <b-button variant="outline-primary" style="display:none;"></b-button>
              <b-button variant="outline-primary" style="display:none;"></b-button>
            </template>
          </b-modal>
        </b-row>
        <!-- 2022-02-14 매장이미지 추가 end -->

        <div class="mb-4"></div>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import SortableFileUploader from "../../../../components/Upload/SortableFileUploader.vue";
import SubImageContentViewer from "./SubImageContentViewer";
import EditGoodsSubImages from "./EditGoodsSubImages";
import EditSubImageContent from "./EditSubImageContent";
import AvailableStore from './AvailableStore.vue';
import EventBus from '../../../../utils/EventBus';
import StoreFileUpLoad from '../../../../components/Upload/StoreFileUpLoad.vue';
import api from '../../../../constants/api';

import {
  rescode,
} from "../../../../constants/common";
import {
  reqGet,
  reqPost
} from "../../../../constants/request";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {
  quillEditor
} from 'vue-quill-editor';
import {
  Drag,
  Drop
} from "vue-drag-drop";

import {
  mapGetters,
  mapActions,
  mapMutations,
  Store
} from "vuex";

export default {
  components: {
    Drag,
    Drop,
    StoreFileUpLoad,
    AvailableStore,
    'sortable-file-uploader': SortableFileUploader,
    'quill-editor': quillEditor,
    'sub-image-content-viewer': SubImageContentViewer,
    'edit-sub-image-content': EditSubImageContent,
    'edit-goods-sub-images': EditGoodsSubImages
  },
  data() {
    return {
      titleArr: [],
      imgdragselect: null,
      subtext: true,
      subImagesBtnType: '',
      spinning: false,
      fofo: true,
      parantRemove: '',
      isthree: false,
      fakeIndex: [],
      existence: false,
      addStoreImgUse: false,
      filesDataCopy: [],
      newsubimguse: false,
      clickval: null,
      ReflectVal: null,
      imgDragList: [],
      storeTitleList: [],
      storeList: [],
      imgFile: {},
      trueImg: "",
      imgFile2: {},
      trueImg2: "",
      showDragImg: true,
      showDragImg2: false,
      isModifyMode: false,
      isReqModifyMode: false,
      goodsParamsId: null, //등록된 상품아이디
      registerId: null, //등록대기 상품아이디

      copyRegisterId: null,
      editMainImgFlag: false,
      transProps: {
        // Transition name
        name: 'list'
      },
      tempImageInfo: null,
      openModalForModify: false,
      subImageMaxIndex: 0,
      editorOptionBubble: {
        theme: 'bubble',
        placeholder: '',
        modules: {
          toolbar: [
            [
              'bold',
              'italic',
              'link',
              {
                header: 1
              },
              {
                header: 2
              },
              'blockquote'
            ]
          ]
        }
      },
      //서브이미지 추가/수정 임시저장변수
      tempSubContent: {
        id: 0,
        title: null,
        description: null,
        images: []
      },
      //매장이미지 임시저장변수
      tempSubContent2: {
        id: 0,
        title: null,
        description: null,
        images: [{
          "width": 0,
          "height": 0,
          "url": null,
          "azureUrl": null
        }]
      },
      updateSubContentIndex: 0,
      //메인이미지 추가/정 임시저장변수
      tempMainContent: [],
      //메인이미지 매장이미지 임시저장변수
      tempMainContent2: [{
        "width": 0,
        "height": 0,
        "url": null,
        "azureUrl": null
      }],
      reqImgBackground: "",
      reqImgBackground2: [{
        "width": 0,
        "height": 0,
        "url": null,
        "azureUrl": null
      }],
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName', 'goodsTypeOption', 'goodsType', 'goodsName', 'goodsTag', 'intro', 'mainImage', 'subImages', 'storeCodes']),

    _goodsType: {
      get() {
        return this.goodsType
      },
    },
    _storeCodes: {
      get: function () {
        return this.storeCodes
      },
      set: function (e) {
        this.setStoreCodes(e)
      }
    },
    _goodsTypeOption: {
      get() {
        return this.goodsTypeOption
      },
    },

    _goodsName: {
      get: function () {
        return this.goodsName
      },
      set: function (e) {
        this.setGoodsName(e)
      }
    },
    _goodsTag: {
      get: function () {
        return this.goodsTag
      },
      set: function (e) {
        this.setGoodsTag(e)
      }
    },
    _intro: {
      get: function () {
        return this.intro
      },
      set: function (e) {
        this.setIntro(e)
      }
    },
    _mainImage: {
      get: function () {
        return this.mainImage
      },
      set: function (e) {
        this.setMainImage(e)
      }
    },
    _mainImage2: {
      get: function () {
        return this.mainImage
      },
      set: function (e) {
        this.setMainImage(e)
      }
    },
    _subImages: {
      get: function () {
        return this.subImages
      },
      set: function (e) {
        this.setSubImages(e)
      }
    },
  },

  watch: {

    tempSubContent2:{
      deep: true,
      handler(newData) {
        this.tempSubContent2.images = newData.images;
        // console.log(newData.images)
      },
    },

    _mainImage() {
      if (this._mainImage) {

        if (this.tempMainContent.length == 0) {
          //상품수정시 메인이미지 썸네일 추가
          this.tempMainContent.push({
            "name": "TestName.jpg",
            "size": 20000,
            "type": "image/jpeg",
            "ext": "jpg",
            "url": this._mainImage.url,
            "height": this._mainImage.height,
            "width": this._mainImage.width
          })
        } else {
          this.tempMainContent = [];
          this.tempMainContent.push({
            "name": "TestName.jpg",
            "size": 20000,
            "type": "image/jpeg",
            "ext": "jpg",
            "url": this._mainImage.url,
            "height": this._mainImage.height,
            "width": this._mainImage.width
          })
        }
      }
    },
    _subImages() {
      // console.log( this._subImages)
    },
    goodsType(val) {
      // console.log(val === "MoneyCoupon")
      if (val === "MoneyCoupon") {
        alert('해당 상품이 존재하지 않습니다.');
        this.$router.go(-1);
      }
    }

  },
  mounted() {
    //신규상품
    this.registerId = this.$route.params.registerId !== undefined ? this.$route.params.registerId : null
    if (this.registerId !== null) {
      this.isReqModifyMode = true;
    }

    //등록상품
    this.goodsParamsId = this.$route.params.goodsId !== undefined ? this.$route.params.goodsId : null
    if (this.goodsParamsId !== null) {
      this.isModifyMode = true;
      this.evebusStore();
    }
    this.evebusStore();

  },

  methods: {
    titleArrClcik(titleArr) {
      // console.log(titleArr)
      this.imgDragList = [];
      titleArr.storeImages.forEach((el, idx) => {
        this.imgDragList.push({
          url: el.url,
          width: el.width,
          height: el.height,
        })
      });
    },
    storeImgList() {
      reqGet(
        this.requrlChange(api.shop.storeImageslistBRD, api.shop.storeImageslistSTR, "?storeCode=" + this.imgdragselect, "?storeCode=" + this.imgdragselect),
        this.currentUser.tokens.access.token,
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              this.imgDragList = [];
              this.imgDragListOriginal = [];
              // console.log(result.data.list)
              this.titleArr = [];
              //titleArr
              result.data.list.forEach(el => {
                // console.log(.url)
                this.titleArr.push({
                  title: el.title,
                  storeImages: el.storeImages
                })
                this.imgDragListOriginal = JSON.parse(JSON.stringify(this.imgDragList));
              });
              this.titleArrClcik(result.data.list[0]);
            } else {
              alert(result.message);
            }
          }
        }
      );
    },
    evebusStore() {
      //2022-02-16 리뉴얼 매장이미지 추가시 매장리스트 뿌리기
      EventBus.$on('storelistBus', (store, list) => {
        this.storeList = [];
        list.forEach((el, idx) => {
          store.forEach(st => {
            if (list[idx] === st.value) {
              this.storeList.push(st);
              this.imgdragselect = st.value;
            }
          });
        });
      });
      this.storeImgList();
    },
    ...mapActions(['goodsReset', 'goodsId', 'reqGoodsCreate', 'reqGoodsUpdate', 'goodsRegister', 'goodsInfo', 'reqGoodsInfo',
      'goodsUpdateIntro', 'goodsUpdateCondition', 'goodsUpdateOptionsAndUsableHours', 'goodsUpdateOptions', 'goodsUpdateUsage',
      'goodsChannelCodesOptions'
    ]),
    // storelistFun() {
    //     if (this.goodsParamsId !== null) {
    //         this.goodsInfo({
    //             currentUser: this.currentUser,
    //             siteName: this.siteName
    //         });
    //     }

    // },
    spinningeve(val) {
      // console.log(val)
      if (val === true) {
        this.spinning = true;
      }

    },
    usefilesData(val) {
      // console.log()
      if (val) {
        // console.log(this.fakeIndex)
        this.filesDataCopy = val; //삭제시에 필요한 파일정보
        // let fofo = true;
        if (this.newsubimguse) {

          // console.log(this.tempSubContent2.images)

          if (this.subImagesBtnType === 'edt') {
            this.reqImgBackground2 = [];
            this.reqImgBackground2.unshift({
              "width": 0,
              "height": 0,
              "url": null,
              "azureUrl": null,
              'firstpar': 'ok',
            })
            this.subImagesBtnType = 'none'
          }
          this.tempSubContent2.images.forEach(el => {
            if (el.url !== null) {
              this.reqImgBackground2.push(el)
            }
          });
          // 파일업로드 다중으로 할시에는 중복된값이 들어옴 삭제 해줘야함
          const map = new Map();
          for (const character of this.reqImgBackground2) {
            map.set(JSON.stringify(character), character);
          }
          const arrUnique = [...map.values()];
          this.reqImgBackground2 = arrUnique;
          if (this.reqImgBackground2.length === 4) {
            // this.reqImgBackground2.shift();
            this.reqImgBackground2.forEach((el, idx) => {
              if (el.url === null) {
                this.reqImgBackground2.splice(idx, 1)
              }
            });
          }
          this.fakeIndex.push('s') //이미지 삭제시 사용
          if (val.length === 3) {
            if (this.fakeIndex.length === 3) {
              this.spinning = false;
            }
          } else if (val.length === 2) {
            if (this.fakeIndex.length === 2) {
              this.spinning = false;
            }
          } else if (val.length === 1) {
            if (this.fakeIndex.length === 1) {
              this.spinning = false;
            }
          }
        } else {
          this.reqImgBackground = val[0].url; // 백그라운드이미지url에 넣을 url
        }
        // this.spinning = false;
      }

    },
    ondrop(event, idx) {
      event.preventDefault();
      var data = event.dataTransfer.getData("Text");

    },
    dropboxClick(idx) {
      this.clickval = Math.random();
      this.fofo = true;
    },
    allowDrop(event) {
      event.preventDefault();
    },
    drag(event) { //드래그 시작시 호출 할 함수
      event.dataTransfer.setData("Text", event.target.id);
      const targetEl = document.getElementById('holder');
    },
    onDragenter(event) {
      event.preventDefault()
    },
    onDragover(event) {
      event.preventDefault()
    },
    sumimagesort(drop, drag) {
      console.log(drag)
      if (drag !== undefined) {
        if (drag.mark != 'subimgs') {
          return;
        }
        var t_array = this.reqImgBackground2;
        this.reqImgBackground2 = [];
        var b = t_array[drag.index];
        t_array[drag.index] = t_array[drop];
        t_array[drop] = b;
        this.reqImgBackground2 = t_array;
      }
    },
    _mainImage2Push() {
      if (this._mainImage2) {
        if (this.tempMainContent2.length == 0) {
          //상품수정시 메인이미지 썸네일 추가
          this.tempMainContent2.push({
            "name": "TestName.jpg",
            "size": 20000,
            "type": "image/jpeg",
            "ext": "jpg",
            "url": this._mainImage2.url,
            "height": this._mainImage2.height,
            "width": this._mainImage2.width
          })
        } else {
          this.tempMainContent2 = [];
          this.tempMainContent2.push({
            "name": "TestName.jpg",
            "size": 20000,
            "type": "image/jpeg",
            "ext": "jpg",
            "url": this._mainImage2.url,
            "height": this._mainImage2.height,
            "width": this._mainImage2.width
          })
        }
      }
    },
    imgReflect() {
      if (this._mainImage2.length !== 0) {
        this.tempMainContent = this.tempMainContent2;
        this.ReflectVal = this.tempMainContent2;
        this.$refs['storeimgdlg'].hide();
      } else {
        alert('대표 이미지를 선택해주세요.');
        return;
      }
    },
    ...mapMutations(['setGoodsName', 'setGoodsTag', 'setIntro', 'setMainImage', 'setSubImages', 'setStoreCodes']),

    onEditorChange({
                     editor,
                     html,
                     text
                   }) { //상품설명 에디터
      this._intro = text
    },
    storeTableClose(type) {
      if (type === 'represent') {
        this.showDragImg = true;
      } else {
        this.showDragImg2 = false;
        this.addStoreImgUse = true;
        this.subtext = true;
      }

    },
    storeAddSelect(type) {

      EventBus.$emit('setStore', '');
      if (type === 'represent') {
        this.showDragImg = true;
      } else if (type === 'none') {

      } else {
        this.showDragImg2 = false;
        this.addStoreImgUse = true;
        this.subtext = true;
      }
      this.storeImgList();
    },
    onSubEditorChange({
                        editor,
                        html,
                        text
                      }) { //서브이미지컨텐츠 에디터
      this.tempSubContent.description = text
    },
    repImageModal() {
      this.$refs['storeimgdlg'].show();
      this.newsubimguse = false;
      if (this._mainImage.url !== null) {
        this.tempMainContent2 = [{
          "width": this._mainImage.width,
          "height": this._mainImage.height,
          "url": this._mainImage.url,
          "azureUrl": this._mainImage.url,
        }];
        this._mainImage2 = this._mainImage;
        this.reqImgBackground = this._mainImage.url;
      } else {
        this.tempMainContent2 = [{
          "width": 0,
          "height": 0,
          "url": null,
          "azureUrl": null
        }];
        this._mainImage2 = [];
        this.reqImgBackground = null;
      }
      this.storeAddSelect('none');
      // this.storelistFun();
    },
    mainImageHandling(file) { //대표이미지 핸들링
      if (file.length > 0) {
        let _url = file[0].azureUrl ? file[0].azureUrl : file[0].url;
        this._mainImage = {
          width: file[0].width,
          height: file[0].height,
          url: _url,
          azureUrl: _url
        }
      } else {
        this._mainImage = null
      }
    },
    mainImageHandling2(file) { //대표이미지 매장이미지 핸들링
      // console.log(file)
      if (file.length > 0) {
        let _url = file[0].azureUrl ? file[0].azureUrl : file[0].url;
        this._mainImage2 = {
          width: file[0].width,
          height: file[0].height,
          url: _url,
          azureUrl: _url
        }
        // console.log(this._mainImage2)
        this._mainImage2Push();
      } else {
        this._mainImage2 = null
      }
    },
    newmainimgstoreadd(url, width, height) {
      let _url = url;
      this._mainImage2 = {
        width: width,
        height: height,
        url: _url,
        azureUrl: _url
      }
      this._mainImage2Push();
    },
    usestoreedit(type) {
      if (type === 'represent' || !type) {
        this.showDragImg = false;
      } else if (type === 'sub') {
        this.showDragImg2 = true;
        this.addStoreImgUse = false;
        this.subtext = false;
      }
    },
    subImageHandling(files) { // 서브이미지콘텐츠안에 있는 이미지 핸들링

      this.tempSubContent.images = []
      if (files.length > 0) {
        // console.log(files);
        let vm = this
        files.forEach(function (value, index) {
          let _url = value.azureUrl ? value.azureUrl : value.url;
          // console.log(value)
          vm.tempSubContent.images.push({
            width: value.width,
            height: value.height,
            url: _url,
            azureUrl: _url
          })
        })
      }

    },
    subImageHandling2(files) { // 서브이미지콘텐츠안에 있는 이미지 핸들링

      this.tempSubContent2.images = []
      if (files.length > 0) {
        // console.log(files);
        let vm = this
        files.forEach(function (value, index) {
          let _url = value.azureUrl ? value.azureUrl : value.url;
          // console.log(value)
          vm.tempSubContent2.images.push({
            width: value.width,
            height: value.height,
            url: _url,
            azureUrl: _url
          })
        })
      }

    },
    newsubimgstoreadd(url, width, height) {
      // let _url = url;
      if (this.newsubimguse) {
        // this.tempSubContent2.images.push({
        //     width: width,
        //     height: height,
        //     url: url,
        //     azureUrl: url,
        // });
        this.tempSubContent2.images = url;
      }
      // console.log()

    },

    //임시 저장변수 초기화
    tempSubContentReset() {
      this.tempSubContent = {
        id: 0,
        title: null,
        description: null,
        images: []
      }
      this.tempSubContent2 = {
        id: 0,
        title: null,
        description: null,
        images: []
      }
    },

    /** 서브이미지 추가 **********************************************************************************************/
    //서브이미지추가 버튼클릭
    openSubContentModal(modal) {
      this.newsubimguse = true;
      this.subImagesBtnType = 'add';
      this.tempSubContent = {
        title: null,
        description: null,
        images: []
      }
      this.tempSubContent2 = {
        title: null,
        description: null,
        images: [{
          "width": 0,
          "height": 0,
          "url": null,
          "azureUrl": null
        }]
      }
      this.reqImgBackground2 = [{
        "width": 0,
        "height": 0,
        "url": null,
        "azureUrl": null
      }];
      this.openModalForModify = false
      this.$refs['modalbackdrop'].show();
      this.storeAddSelect('none');
    },

    //서브이미지추가
    addSubImageContents() {

      let findss = this.tempSubContent2.images.filter(function (item) {
        return item.url !== null;
      });

      if (findss.length !== 0) {
        this.$refs.subImages.uploadImgArr();
        this.tempSubContent2.images = findss;
      } else {
        alert('이미지 파일을 추가해주세요');
        return
      }

      // console.log(this.tempSubContent2.images)

      if (this.tempSubContent2.images.length > 0) {

        // if (this.isModifyMode || this.isReqModifyMode) {

        // }
        this.subImageMaxIndex = this._subImages.length
        this._subImages.push({
          id: this.subImageMaxIndex++,
          title: this.tempSubContent.title,
          description: this.tempSubContent.description,
          images: this.tempSubContent2.images
        })
        // console.log(this.tempSubContent2.images)
        this.tempSubContentReset()
        this.hideModal()
      } else {
        alert('이미지 파일을 추가해주세요');
      }
    },

    /** 서브이미지 수정 **********************************************************************************************/
    //서브이미지 수정시 기본값 설정
    editSubImageContent(subImageContentId) {
      this.newsubimguse = true;
      this.subImagesBtnType = 'edt';
      this.tempSubContentReset();
      const index = this._subImages.findIndex(item => item.id === subImageContentId)

      this._subImages[index].images.forEach(function (v, i) { // 파일 특성상 가짜 이름과 타입 사이트 지정
        v.name = "TestName.jpg"
        v.size = 2000
        v.type = "image/jpeg"
        v.ext = "jpg"
      })

      let tmp = this.copyObj(this._subImages[index]);
      this.updateSubContentIndex = tmp.id
      this.tempSubContent = tmp;
      this.tempSubContent2 = tmp;
      this.fakeIndex = [];
      tmp.images.forEach((el, idx) => {
        this.fakeIndex.push(idx)
      });
      // console.log(this.tempSubContent2.images)
      this.openModalForModify = true
      this.$refs['modalbackdrop'].show();
      this.storeAddSelect('none');
    },
    copyObj(obj) {
      let copy = {};
      if (Array.isArray(obj)) {
        copy = obj.slice().map((v) => {
          return this.copyObj(v);
        });
      } else if (typeof obj === 'object' && obj !== null) {
        for (let attr in obj) {
          if (obj.hasOwnProperty(attr)) {
            copy[attr] = this.copyObj(obj[attr]);
          }
        }
      } else {
        copy = obj;
      }
      return copy;
    },

    //서브이미지 수정적용
    updateSubImageContents() {
      let vm = this
      let findss = this.tempSubContent2.images.filter(function (item) {
        return item.url !== null;
      });

      if (findss.length !== 0) {
        this.$refs.subImages.uploadImgArr();
        this.tempSubContent2.images = findss;
      } else {
        alert('이미지 파일을 추가해주세요');
        return
      }
      if (vm.tempSubContent2.images.length > 0) {

        // console.log(vm.tempSubContent2.images)
        const origin_index = vm._subImages.findIndex(
          element => element.id === vm.updateSubContentIndex); //기존위치
        const notIncludeObject = vm._subImages.filter(
          element => element.id !== vm.updateSubContentIndex); // 수정할 인덱스를 제외한 나머지 데이터
        const last_index = vm._subImages.length - 1 // 배열의 마지막을 수정했을때를 대비해서 마지막 배열크기

        if (vm.subImageMaxIndex == 0 && vm._subImages.length > 0) { // 수정시 서브 이미지의 인덱스 만큼 최초 설정을 해주어야 함. 이미 화면에 그려지기 때문.
          vm.subImageMaxIndex = vm._subImages.length;
        }
        let cnt = vm.subImageMaxIndex++ //뷰에 특성상 동적으로 화면이 바뀌려면 id 값이 겹치면 안된다. ( 수정시에도 증가해야 화면이 업데이트 됨 )
        let newObject = [];
        let updateData = {
          id: cnt,
          title: vm.tempSubContent.title,
          description: vm.tempSubContent.description,
          images: vm.tempSubContent2.images
        }

        notIncludeObject.forEach(function (value, index) {
          if (index == origin_index) { //중간을 수정했을경우 신규 수정한 데이터 먼저 넣어줌
            newObject.push(updateData)
          }
          newObject.push(value) // 나머지 데이터 넣음
        })
        if (origin_index === last_index) { //마지막 데이터 수정시
          newObject.push(updateData)
        }
        this._subImages = newObject;
        // console.log(this._subImages)

      } else {
        this._subImages = [];
      }
      this.hideModal()
    },

    /** 서브이미지 이동 **********************************************************************************************/
    moveUpSubImageContent(subImageContentId) {
      if (this._subImages.length <= 1) {
        return false
      }
      const index = this._subImages.findIndex(element => element.id === subImageContentId);
      if (index <= 0) {
        return false
      }
      let preItem = this._subImages[index - 1];
      let clickedItem = this._subImages[index];
      this._subImages.splice(index - 1, 2, clickedItem, preItem)
    },

    moveDownSubImageContent(subImageContentId) {
      if (this._subImages.length <= 1) {
        return false
      }
      const index = this._subImages.findIndex(element => element.id === subImageContentId);
      if (index >= (this._subImages.length - 1)) {
        return false
      }
      let postItem = this._subImages[index + 1];
      let clickedItem = this._subImages[index];
      this._subImages.splice(index, 2, postItem, clickedItem)
    },

    /** 서브이미지 삭제 **********************************************************************************************/
    removeSubImageContent(subImageContentId) { //서브이미지 삭제
      this._subImages = this._subImages.filter(item => item.id !== subImageContentId)
    },

    cancelSubImageContents() { //서브이미지 모달취소
      this.tempSubContentReset();
      this.hideModal()
    },

    hideModal() {
      this.$refs['modalbackdrop'].hide();
    },
    requrlChange(brdapiName, strapiName, brdquerystring, strquerystring) {
      let reqURL = ''
      if (this.currentUser.userRole.split('_')[0] == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + brdapiName) + brdquerystring
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + strapiName) + strquerystring
      }
      return reqURL
    }
  },
}
</script>

<style lang="scss" scoped>
.list-move {
  transition: transform 1s;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter,
.list-leave-to

  /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

input::placeholder {
  color: #b0b0b0;
}

.imgBoxDivGroup {
  width: 50%;
}

.imgBoxDivGroup .imgDragbox {
  width: 100%;
}

.imgBoxDivGroup {
  display: flex;
  width: 100%;
  justify-content: center;
}

.imgboxChild:nth-child(1n) {
  margin-right: 10px;
}

.imgBoxDivGroup > div .imgboxChild {
  height: 200px;
  width: 200px;
  margin-bottom: 10px;
  display: inline-block;
  object-fit: contain;
  background: #f5f5f5;
  padding: 10px;
}

.imgDragbox {
  text-align: center;
  padding: 20px;
  margin-left: 20px;
  width: 50%;
}

.dropbox img {
  display: none !important;
}

.dropbox {
  width: 100%;
  height: 100%;
  margin: auto;
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

.dropboxDiv {
  width: 400px;
  height: 300px;
  padding: 24px;
  background: #f2f2f2;
  border: 1px solid #dedede;
  position: relative;
  background: #f2f2f2 url(/assets/img/plusimg.PNG);
  background-repeat: no-repeat;
  background-position: center;
}

.dropboxDiv.sub {
  width: 200px;
  height: 150px;
}

.partentDiv {
  position: relative;
}

.imgClose {
  position: absolute;
  right: 9px;
  z-index: 99;
  top: 5px;
}

.upimg {
  fill: #aaa;
  margin: auto;
  margin-top: 16%;
  height: 36%;
  width: 100%;
}

.help-text {
  color: #aaa;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  height: 20px;
  display: block;
}

.upimgtextbox {
  height: 100%;
}

.imgdragselect {
  width: auto;
  // margin-left: 14px;
  margin-bottom: 10px;
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
  height: auto !important;
}

.imgDragbox-div {
  text-align: left;
}

.btn-default {
  background-color: #f4f4f4;
  color: #444;
  border-color: #ddd;
  border-radius: 0;
}

.dropImgBox::-webkit-scrollbar {
  width: 6px;
}

.dropImgBox::-webkit-scrollbar-track {
  background-color: grey;
}

.dropImgBox::-webkit-scrollbar-thumb {
  background-color: #2f3542;
}

.dropImgBox {
  height: 400px;
  text-align: left;
  overflow: auto;
}

.addmodals {
  display: flex;
  justify-content: space-between;
}

.addmodals .imgBoxDivGroup {
  width: 50%;
}

.addimgInputGroup {
  width: 45%;
  vertical-align: top;
}

.addmodals .imgBoxDivGroup .imgDragbox {
  width: 100%;
}

.newmmsubsim {
  display: flex;
  justify-content: flex-start;
}

.positon-r {
  position: relative;
}

.mouseC {
  cursor: move;
}

.useimgdiv1 {
  width: 85%;
  padding-left: 11px;
}

.juu {
  display: flex;
  justify-content: space-between;
}
</style>
